import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { MovimentationForm } from 'src/@types/validations/Animal'
import { useCreateAnimalHistoric, useCreateProductiveAnimal, useUpdateAnimal } from 'src/hooks/api/animal'
import { useCreateAnimalMovimentation } from 'src/hooks/api/animal/mutations/useCreateAnimalMovimentation'
import { toast } from 'react-toastify'
import { toastSyncSuccess } from 'src/utils/syncToast'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'
import { calculateAndSaveProductiveAndHistoric } from 'src/services/calculateAndSaveProductiveAndHistoric'

export const useMovimentation = () => {
  const { username, userFarm: farmId } = useAuth()

  const [isSaving, setIsSaving] = useState(false)
  const { reset } = useFormContext<MovimentationForm>()

  const { mutateAsync: updateAnimalMutation } = useUpdateAnimal()
  const { mutateAsync: createAnimalMovimentation } = useCreateAnimalMovimentation()

  const { mutateAsync: createHistoric } = useCreateAnimalHistoric()
  const { mutateAsync: createProductive } = useCreateProductiveAnimal()

  const animalController = new AnimalController()

  const createMovimentation = async (animalId: string, formData: MovimentationForm) => {
    const productiveAnimalHistoric = await animalController.getProductiveAnimalList(farmId!, animalId)

    try {
      const animalData = await animalController.getAnimalById(farmId!, animalId)

      await createAnimalMovimentation({
        data: new Date().toISOString(),
        idAnimal: animalId!,
        nome: username!,

        loteOrigem: animalData.idPastoAtual!,
        loteDestino: formData.loteDestino!,

        pastoOrigem: animalData.idPastoAtual!,
        pastoDestino: formData.pastoDestino!
      })

      const animalDataPayload = {
        ...animalData,
        idAnimal: animalId!,
        idLoteAtual: formData.loteDestino! || animalData.idLoteAtual,
        idPastoAtual: formData.pastoDestino! || animalData.idPastoAtual
      }

      await updateAnimalMutation(animalDataPayload)

      await calculateAndSaveProductiveAndHistoric({
        productiveAnimalHistoric,
        formData: animalDataPayload as any,
        createProductive,
        createHistoric
      })
    } catch (error) {
      toast.error('Erro ao movimentar animal')
      console.error('Error during animal movimentation:', error)
    }
  }

  const onSubmit = async (formData: MovimentationForm) => {
    setIsSaving(true)

    if (formData.tipoMovimentacao === 'animal') {
      await createMovimentation(formData.idAnimal!, formData)
      reset()
      setIsSaving(false)
      toastSyncSuccess('Animal movimentado com sucesso')
      return
    }

    if (!formData.animals.length) {
      setIsSaving(false)
      return
    }

    await Promise.all(formData.animals.map((animalId) => createMovimentation(animalId, formData)))

    reset()
    setIsSaving(false)
    toastSyncSuccess('Animais movimentados com sucesso')
  }

  return {
    isSaving,
    onSubmit
  }
}
